var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client"},[_c('ClientMenu',{staticClass:"menu"}),_c('div',{staticClass:"right-panel"},[_c('div',{staticClass:"context-panel"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }